import { gql } from 'apollo-angular';

import { CONFIGURATION_VARIABLE_FRAGMENT } from 'graphql/fragments/configuration-variable';

export const PRODUCT_LINE_SECTIONS_VARIABLES_FRAGMENT = gql`
  fragment ProductLineSectionsVariablesFragment on ProductLine {
    configuration {
      sections(filter: { isVisible: true }) {
        id
        name
        showFilterProp: property(name: "showFilter") {
          valueText
        }
        sections (flatten: true) {
          id
          name
          showFilterProp: property(name: "showFilter") {
            valueText
          }
          variables: filteredVariables(paging: { page: 0, perPage: 250 }, filter: { isVisible: true }) {
            items {
              ...ConfigurationVariableFragment
            }
          }
        }
      }
    }
  }
  ${CONFIGURATION_VARIABLE_FRAGMENT}
`;
